export default __webpack_public_path__ + "static/media/spinner.36015fe1.png";